import fetchSubjectTypes from '@Application/SubjectTypes/fetchSubjectTypes';
import FetchSubjectTypes from '@Application/SubjectTypes/Queries/FetchSubjectTypes';
import useAuthenticatedUser from '@UI/Providers/AuthenticatedUserProvider/useAuthenticatedUser';
import type SubjectTypesListView from '@UI/Store/SubjectTypes/Views/SubjectTypesListView';
import { useDispatch, useStoreQuery } from '@verclam/synapse';

export type UseSubjectTypesResult = {
	types: SubjectTypesListView | null;
	error: Error | null;
};

/** Loads the dossier types of the current account. Without an account, nothing is requested. */
function useSubjectTypes(): UseSubjectTypesResult {
	const dispatch = useDispatch();
	const { user } = useAuthenticatedUser();
	const accountId = user?.account?.id ?? null;

	const { data: types, error } = useStoreQuery({
		selector: (state) => state.subjectTypesStore.types,
		stopOn: (value) => accountId === null || (value !== null && value.accountId === accountId),
		query: () => {
			if (accountId === null) {
				return Promise.resolve();
			}

			return dispatch(fetchSubjectTypes(new FetchSubjectTypes(accountId)));
		},
		deps: [accountId],
	});

	return { types, error };
}

export default useSubjectTypes;
